import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { Container } from '../../styles/GlobalStyles';

export default function Page404() {
   return (
      <Container>
         <FaInfoCircle size={40} />
         <br />
         <h2>Essa página não existe.</h2>
         <br />
         <p>
            A página que você procura não existe ou foi removida. Verifique o
            endereço digitado.
         </p>
      </Container>
   );
}
